export default __webpack_public_path__ + "static/media/close.2cc142e7.svg";